export function createCountdown(durationMs, elapsedMs = 0) {
    const duration = Math.max(0, durationMs);
    // Time used before the current run; while running, the run started at `since`.
    let used = Math.min(duration, Math.max(0, elapsedMs));
    let since = null;
    const usedAt = (now) => (since === null ? used : used + Math.max(0, now - since));
    const remaining = (now) => Math.max(0, duration - usedAt(now));
    const resume = (now) => {
        if (since === null)
            since = now;
    };
    return {
        start: resume,
        resume,
        pause(now) {
            if (since === null)
                return;
            used = Math.min(duration, usedAt(now));
            since = null;
        },
        remaining,
        expired: (now) => remaining(now) <= 0,
        running: () => since !== null,
    };
}
/** The seconds a timed toast shows: whole seconds, rounded up ("8 s"). */
export function secondsLeft(remainingMs) {
    return Math.ceil(Math.max(0, remainingMs) / 1000);
}
//# sourceMappingURL=countdown.js.map